import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useParams } from 'react-router-dom';
import { useSystem } from '../../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { AnimatePageWidget } from '../../../../widgets/layout/AnimatePageWidget';
import { TabWidget } from '../../../../widgets/controls/TabWidget';
import { PackMembersWidget } from './PackMembersWidget';
import { PackModel } from '../../../../core/models/PackModel';
import { GroupUserStatus } from '@foxbun/lib-goferal-types';
import { EmptyWidget } from '../../../../widgets/content/EmptyWidget';
import { AboutSectionWidget } from '../../../../widgets/pages/AboutSectionWidget';
import { PackHeaderWidget } from './PackHeaderWidget';

export enum PackTabs {
  ABOUT = 'About',
  MEMBERS = 'Members'
}

export const PackPage: React.FC = observer((props) => {
  const system = useSystem();
  const params = useParams<{ id: string }>();
  const pack = system.pack_store.getModel(params.id);

  useEffect(() => {
    pack.refresh();
    pack.loadMyRelation();
  }, [pack]);

  if (!pack.data) {
    return null;
  }

  return (
    <AnimatePageWidget slide={true}>
      <PackHeaderWidget pack={pack} />
      {pack.my_status?.status === GroupUserStatus.ACCEPTED ? (
        <PackContentWidget pack={pack} />
      ) : (
        <EmptyWidget label="Need to be accepted to see more!" />
      )}
    </AnimatePageWidget>
  );
});

export const PackContentWidget: React.FC<{ pack: PackModel }> = observer((props) => {
  const [tab, setTab] = useState(PackTabs.ABOUT);
  return (
    <S.Section>
      <TabWidget
        tabs={[PackTabs.ABOUT, PackTabs.MEMBERS]}
        selected={tab}
        onChange={(selected) => {
          setTab(selected as PackTabs);
        }}
      ></TabWidget>
      <S.TabContent>{tab === PackTabs.ABOUT ? <AboutSectionWidget model={props.pack} /> : null}</S.TabContent>
      <S.TabContent>{tab === PackTabs.MEMBERS ? <PackMembersWidget pack={props.pack} /> : null}</S.TabContent>
    </S.Section>
  );
});

namespace S {
  export const Section = styled.div`
    padding: 20px;
  `;

  export const TabContent = styled.div`
    margin-top: 10px;
  `;
}
